import classNames from 'classnames';

import lang from '../../lib/language';

import useBrowserWidth from '../hooks/useBrowserWidth';
import useIsMobile from '../hooks/useIsMobile';

import PopularGroupItems from './PopularGroupItems/PopularGroupItems';
import { PopularGroupsProps } from './PopularGroups.types';

import styles from './PopularGroups.module.scss';

const SCROLL_MAX_WIDTH = 1220;

const PopularGroups = ({
  groups,
  isLoading,
  showEtf,
  onGroupClick,
}: PopularGroupsProps) => {
  const { isMobile } = useIsMobile();
  const { browserWidthSize } = useBrowserWidth();
  const shouldScroll = browserWidthSize <= SCROLL_MAX_WIDTH;

  const items = (
    <PopularGroupItems
      groups={groups}
      isLoading={isLoading}
      showEtf={showEtf}
      onGroupClick={onGroupClick}
    />
  );

  return (
    <>
      <h6 className={classNames(GlobalClassesEnum.CommonDiscoverTitle,
        { [styles.titleMobile]: isMobile },
        { [styles.title]: !isMobile }
      )}>
        {lang.commonDiscoverSubtitlePopularGroups()}
      </h6>
      {shouldScroll ? (
        <div className={styles.wrapper}>
          <div className={styles.content}>
            {items}
          </div>
        </div>
      ) : items}
    </>
  );
};

export default PopularGroups;
